var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Icon, Loading, LoadingPane, NavList, NavListItem, NavListSection, Pane } from '@folio/stripes/components';
import { TitleManager, useStripes } from '@folio/stripes/core';
import classNames from 'classnames';
import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Route, useHistory, useRouteMatch } from 'react-router-dom';
import css from '../components/Calendar.css';
import useDataRepository from '../data/useDataRepository';
import { dateUTCToYYYYMMDD, getDateRange, getLocalizedTime } from '../utils/DateUtils';
import MonthlyCalendarView from './panes/MonthlyCalendarView';
export function dailyOpeningToCalendarDisplay(intl, openingInfo) {
    var exception = null;
    var status = (React.createElement("p", { className: css.closed, key: -1 },
        React.createElement(FormattedMessage, { id: "ui-calendar.monthlyCalendarView.day.closed" })));
    if (openingInfo.open) {
        if (openingInfo.allDay) {
            status = (React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "ui-calendar.monthlyCalendarView.day.allDay" })));
        }
        else {
            openingInfo.openings.sort(function (a, b) {
                return a.startTime.localeCompare(b.startTime);
            });
            status = openingInfo.openings.map(function (opening, i) { return (React.createElement("p", { key: i },
                React.createElement(FormattedMessage, { id: "ui-calendar.monthlyCalendarView.day.timeRange", values: {
                        startTime: getLocalizedTime(intl, opening.startTime),
                        endTime: getLocalizedTime(intl, opening.endTime)
                    } }))); });
        }
    }
    if (openingInfo.exceptional) {
        if (openingInfo.open) {
            exception = (React.createElement("span", { className: classNames(css.icon), title: openingInfo.exceptionName },
                React.createElement(Icon, { icon: "exclamation-circle", status: "warn" })));
        }
        else {
            exception = (React.createElement("span", { className: classNames(css.icon), title: openingInfo.exceptionName },
                React.createElement(Icon, { icon: "exclamation-circle", status: "error" })));
        }
    }
    return (React.createElement("div", { key: openingInfo.date },
        status,
        exception));
}
var MonthlyCalendarPickerView = function () {
    var _a, _b;
    var intl = useIntl();
    var stripes = useStripes();
    var dataRepository = useDataRepository();
    var _c = useState({}), events = _c[0], setEvents = _c[1];
    var history = useHistory();
    var currentRouteId = (_b = (_a = useRouteMatch('/settings/calendar/monthly/:servicePointId')) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.servicePointId;
    var getServicePoint = useMemo(function () { return dataRepository.getServicePointFromId(currentRouteId); }, [dataRepository, currentRouteId]);
    useEffect(function () {
        var _a;
        if (currentRouteId !== undefined && !(currentRouteId in events)) {
            var newEvents = __assign(__assign({}, events), (_a = {}, _a[currentRouteId] = {}, _a));
            setEvents(newEvents);
        }
        // we do not care about events changing, we only want to ensure that the SP has an entry
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentRouteId]);
    var requestEvents = useCallback(function (startDate, endDate, servicePointId) { return __awaiter(void 0, void 0, void 0, function () {
        var loadingEvents_1, dateRange, newEvents_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(servicePointId === currentRouteId)) return [3 /*break*/, 2];
                    loadingEvents_1 = __assign({}, events);
                    if (!(servicePointId in loadingEvents_1)) {
                        loadingEvents_1[servicePointId] = {};
                    }
                    getDateRange(startDate, endDate).forEach(function (date) {
                        loadingEvents_1[servicePointId][dateUTCToYYYYMMDD(date)] = React.createElement(Loading, null);
                    });
                    // prevents further calls of this function while these events are being loaded
                    setEvents(loadingEvents_1);
                    return [4 /*yield*/, dataRepository.getDailyOpeningInfo(servicePointId, startDate, endDate)];
                case 1:
                    dateRange = _a.sent();
                    if (dateRange === null)
                        return [2 /*return*/];
                    newEvents_1 = __assign({}, loadingEvents_1);
                    dateRange.forEach(function (openingInfo) {
                        newEvents_1[servicePointId][openingInfo.date] =
                            dailyOpeningToCalendarDisplay(intl, openingInfo);
                    });
                    setEvents(newEvents_1);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); }, [dataRepository, currentRouteId, events, intl]);
    if (!dataRepository.isLoaded()) {
        return (React.createElement(LoadingPane, { paneTitle: React.createElement(FormattedMessage, { id: "ui-calendar.monthlyCalendarView.title" }) }));
    }
    var listItems = dataRepository.getServicePoints().map(function (sp, i) {
        return (React.createElement(NavListItem, { key: i, to: sp.id }, sp.name.concat(sp.inactive ? ' (inactive)' : '')));
    });
    var pageTitle = intl.formatMessage({ id: 'ui-calendar.meta.titleSettings' }) +
        ' - ' + intl.formatMessage({
        id: 'ui-calendar.monthlyCalendarView.title'
    }) + (currentRouteId ? " - ".concat(getServicePoint === null || getServicePoint === void 0 ? void 0 : getServicePoint.name) : '');
    return (React.createElement(TitleManager, { page: pageTitle, stripes: stripes },
        React.createElement(Pane, { defaultWidth: currentRouteId === undefined ? 'fill' : '20%', paneTitle: React.createElement(FormattedMessage, { id: "ui-calendar.monthlyCalendarView.title" }) },
            React.createElement(NavList, null,
                React.createElement(NavListSection, { activeLink: currentRouteId }, listItems))),
        React.createElement(Route, { path: "/settings/calendar/monthly/:servicePointId" },
            React.createElement(MonthlyCalendarView, { onClose: function () {
                    history.push('/settings/calendar/monthly/');
                }, servicePoint: getServicePoint, events: events[currentRouteId !== null && currentRouteId !== void 0 ? currentRouteId : ''], requestEvents: requestEvents }))));
};
export default MonthlyCalendarPickerView;
